import { render, staticRenderFns } from "./radish-list-pro.vue?vue&type=template&id=7464771c&"
import script from "./radish-list-pro.vue?vue&type=script&lang=js&"
export * from "./radish-list-pro.vue?vue&type=script&lang=js&"
import style0 from "./radish-list-pro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports